export default __webpack_public_path__ + "static/media/omkareswara_temple.afb923db.jpg";